import { ids as bookingModalIds, doctorAliases as bookingModalDoctorAliases } from './bookingModal';
import { getDoctorBookingOnline, getDoctorBookingForPreferredTime } from './handlers/getBookingOnlineData';
import { getDoctor, getDoctorForBookingPreferredTime } from './handlers/getDoctorByAlias';
import { ids, doctorAliases } from './timeslots';

export const featureTimeslotsConfig = {
  ids,
  doctorAliases,
};

export const featureBookingModalConfig = {
  ids: bookingModalIds,
  doctorAliases: bookingModalDoctorAliases,
};

export const featureTimeslotsHandlers = {
  getDoctor,
  getDoctorBookingOnline,
};

export const featureBookingModalHandlers = {
  getDoctorForBookingPreferredTime,
  getDoctorBookingForPreferredTime,
};
